import React, { useMemo } from 'react';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { 
  PhantomWalletAdapter, 
  SolflareWalletAdapter, 
  TorusWalletAdapter,
  Coin98WalletAdapter,
  CoinbaseWalletAdapter
} from '@solana/wallet-adapter-wallets';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { clusterApiUrl } from '@solana/web3.js';
import { Wallet, Clock, AlertCircle, CheckCircle, ExternalLink } from 'lucide-react';
import ClaimButton from './components/ClaimButton';
import './App.css';

// Import wallet adapter CSS
import '@solana/wallet-adapter-react-ui/styles.css';

function App() {
  // Set network (Mainnet)
  const network = WalletAdapterNetwork.Mainnet;

  // Get cluster endpoint
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);

  // Configure multiple wallet adapters
  const wallets = useMemo(() => [
    new PhantomWalletAdapter(),
    new SolflareWalletAdapter(),
    new TorusWalletAdapter(),
    new Coin98WalletAdapter(),
    new CoinbaseWalletAdapter()
  ], [network]);

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider 
        wallets={wallets} 
        autoConnect={true}
        onError={(error) => {
          console.error('Wallet connection error:', error);
        }}
      >
        <WalletModalProvider featuredWallets={99}> 
                     
                         <ClaimButton />
          


        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export default App;